import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DetailsOrderClimbRequest, OrderPolishOffRequest, OrderRequest } from '../models/order.model';
import { AccountingEntryUpdateRequest } from '../models/accounting-entry.model';
import { JournalRequest } from '../models/journal.model';

@Injectable({
	providedIn: 'root'
})
export class JournalService {

	private url = environment.api + "api/erp/journal";
	constructor(
		private http: HttpClient,
	) { }

	searchAccountingEntriesByIntervalDate(currentMonth: boolean, endDate: number, startDate: number, pageSize: number, startRow: number) {
		return this.http.get(this.url + "/search?" +
			"currentMonth=" + currentMonth +
			"&endDate=" + endDate +
			"&pageSize=" + pageSize +
			"&startDate=" + startDate +
			"&startRow=" + startRow)
	}

	searchAccountingEntriesByIntervalDateV2(currentMonth: boolean, endDate: number, startDate: number, startRow: number) {
		return this.http.get(this.url + "/search?" +
			"currentMonth=" + currentMonth +
			"&endDate=" + endDate +
			"&startDate=" + startDate +
			"&startRow=" + startRow)
	}

	updateEntryJournal(entryId: number, updateEntry: AccountingEntryUpdateRequest) {
		return this.http.put(this.url + "/" + entryId, updateEntry);
	}

	checkAuxiliaries(toCheck: JournalRequest) {
		return this.http.post(this.url + "/check/auxiliaries", toCheck);
	}

	createJournal(toCreate: JournalRequest) {
		return this.http.post(this.url, toCreate);
	}
}